export default __webpack_public_path__ + "static/media/Utility Shoulders.b9ebee3a.jpg";